// careers-hero-parallax.esm.js
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

function initCareersHeroParallax(root = document) {
    // не прив’язуюсь до data-атрибута, просто шукаю секцію за класом
    const section = root.querySelector(".careersHeroSection");
    if (!section) return;
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const bg = section.querySelector(".careersHeroSection__bg");
    if (!bg) return;

    const AMP_DESKTOP = 0.35;   // було 0.25 → стане помітніше
    const AMP_MOBILE  = 0.22;   // на мобі делікатніше
    const BIAS_PX     = 24;     // старт трохи нижче, щоб верх не обрізало

    const mq = window.matchMedia("(max-width: 768px)");
    const rangePx = () => Math.round(window.innerHeight * (mq.matches ? AMP_MOBILE : AMP_DESKTOP));

    gsap.fromTo(bg,
        { backgroundPosition: () => `50% ${BIAS_PX}px` },
        {
            backgroundPosition: () => `50% ${BIAS_PX + rangePx()}px`,
            ease: "none",
            willChange: "background-position",
            scrollTrigger: { trigger: section, start: "top top", end: "bottom top", scrub: true, invalidateOnRefresh: true }
        }
    );

    const btn = section.querySelector(".careersHeroSection__scroll");
    if (btn) {
        btn.addEventListener("click", () => {
            const next = section.nextElementSibling;
            if (next) next.scrollIntoView({ behavior: "smooth", block: "start" });
        });
    }
}

// автозапуск
if (document.readyState !== "loading") initCareersHeroParallax();
else document.addEventListener("DOMContentLoaded", () => initCareersHeroParallax());

export { initCareersHeroParallax };

function initHeroScroll(root=document){
        root.querySelectorAll('.careersHeroSection__scroll').forEach(btn=>{
            const section = btn.closest('.careersHeroSection');
            if(!section) return;
            let next = section.nextElementSibling;
            // пропустити технічні порожні елементи
            while (next && next.tagName === 'SCRIPT') next = next.nextElementSibling;

            if(!next){ btn.hidden = true; return; }

            const go = () => next.scrollIntoView({ behavior: 'smooth', block: 'start' });
            btn.addEventListener('click', go);
            btn.addEventListener('keydown', (e)=>{
                if(e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
            });
        });
    }

    // ==== Careers page reveals (hero — одразу, інше — тільки при доскролі) ====

    (function runCareersHero() {
        const start = () => {
            const wrap = document.querySelector('.careersHeroSection__wrapper');
            const els = [
                '.careersHeroSection__subtext',
                '.careersHeroSection__title',
                '.careersHeroSection__text'
            ].map(sel => wrap.querySelector(sel)).filter(Boolean);

            // миттєвий старт у найближчий кадр
            requestAnimationFrame(() => {
                gsap.to(els, {
                    autoAlpha: 1,
                    y: 0,
                    duration: 0.6,
                    ease: 'power2.out',
                    stagger: 0.06,
                    lazy: false,
                    overwrite: 'auto',
                    force3D: true
                });
            });
        };

        if (document.readyState !== 'loading') start();
        else document.addEventListener('DOMContentLoaded', start);
    })();

    function initCareersRevealAnimations(root = document) {

        gsap.registerPlugin(ScrollTrigger);

        const ignorePRM = document.documentElement.getAttribute('data-ignore-prm') === '1';
        const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce && !ignorePRM) return;


        // 2) Решта — лише коли доходиш
        const selectors = [
            '.careersCardsSection__subtitle',
            '.careersCardsSection__title',
            '.careersCardsSection__item',
            '.careersPositionsSection__subtitle',
            '.careersPositionsSection__title',
            '.careersPositionsSection__item',
        ];

        const targets = gsap.utils.toArray(selectors.join(',')).filter(el => root.contains(el));

        // стартовий стан
        gsap.set(targets, { autoAlpha: 0, y: 28 });

        targets.forEach((el, i) => {
            // твін СТВОРЮЄМО, але не програємо (ScrollTrigger сам керує)
            const tween = gsap.fromTo(
                el,
                { autoAlpha: 0, y: 28 },
                {
                    autoAlpha: 1, y: 0,
                    duration: 0.6,
                    ease: 'power2.out',
                    immediateRender: false // критично, щоб не відмалювався одразу
                }
            );

            ScrollTrigger.create({
                trigger: el,
                start: 'top 80%',              // коли верх елемента увійшов у 80% вікна
                toggleActions: 'play none none none',
                once: true,
                invalidateOnRefresh: true,
                animation: tween,              // <-- прив'язка без автостарту
                // легка «драбинка» для списків
                onEnter: () => {
                    if (el.matches('.careersCardsSection__item, .careersPositionsSection__item')) {
                        tween.delay((i % 4) * 0.05);
                    }
                }
            });
        });
    }

    document.addEventListener('DOMContentLoaded', () => initCareersRevealAnimations(document));







    if (document.readyState !== 'loading') initHeroScroll();
    else document.addEventListener('DOMContentLoaded', () => initHeroScroll());
    